import {
    DataGrid,
    DataGridProps,
    GridFilterInputDate,
    GridFilterInputMultipleValue,
    GridFilterInputSingleSelect,
    GridNoRowsOverlay,
    GridRow,
    GridToolbarContainer,
    GridToolbarContainerProps,
} from "@mui/x-data-grid";
import { useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { SenecDataGridLinkColumn, SenecDataGridLinkColumnProps } from "src/components/tables/table-utils/SenecDataGridLinkColumn";
import { SenecCheckbox } from "src/components/inputs/senec-checkbox/SenecCheckbox";
import { SenecDataGridPagination } from "src/components/tables/table-utils/SenecDataGridPagination";

/**
 * SenecDataGrid
 *
 * This component, an abstraction of the MUI X DataGrid for shared styling, supports the same properties.
 * Use this component for a styled pagination area; otherwise, the MUI DataGrid is also suitable.
 */
export interface SenecDataGridProps extends DataGridProps {
    enableLinkColumn?: boolean;
    linkColumnProps?: SenecDataGridLinkColumnProps;
}

export const SenecDataGrid = (props: SenecDataGridProps) => {
    const theme = useTheme();

    return (
        <ThemeProvider theme={theme}>
            <DataGrid
                {...props}
                columns={[
                    ...props.columns,
                    ...(props.enableLinkColumn && props.linkColumnProps ? [SenecDataGridLinkColumn(props.linkColumnProps)] : []),
                ]}
                slots={{
                    ...props.slots,
                    baseCheckbox: props.slots?.baseCheckbox ?? SenecCheckbox,
                    noRowsOverlay: props.slots?.noRowsOverlay ?? GridNoRowsOverlay,
                    pagination: SenecDataGridPagination,
                }}
                slotProps={{
                    ...props.slotProps,
                    pagination: { isLoading: props.loading },
                }}
                disableVirtualization={props.disableVirtualization ? props.disableVirtualization : true}
                getRowHeight={props.getRowHeight ? props.getRowHeight : () => 46}
                {...(props.enableLinkColumn &&
                    props.linkColumnProps && {
                        sx: {
                            ...props.sx,
                            "& .MuiDataGrid-cell:last-child": {
                                position: "sticky",
                                right: 0,
                                backgroundColor: theme.palette.background.paper,
                            },
                        },
                    })}
            />
        </ThemeProvider>
    );
};

export const SenecGridToolbarContainer = (props: GridToolbarContainerProps) => {
    return <GridToolbarContainer>{props.children}</GridToolbarContainer>;
};

export const SenecGridFilterDate = GridFilterInputDate;
export const SenecGridFilterInput = GridFilterInputMultipleValue;
export const SenecGridFilterInputSingleSelect = GridFilterInputSingleSelect;
export const SenecGridRow = GridRow;
